import cn from 'classnames';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { FormattedDate, FormattedTime } from 'react-intl/lib';

import { ReportUserSignature } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { useAppSelector } from '@/shared/hooks';
import { getFirstValidJobPosition, getName } from '@/shared/lib';

import { i18n } from '@/entities/organization';
import { userModel } from '@/entities/user';

import styles from './ReportSign.module.scss';

type ReportSignProps = {
  user: ReportUserSignature;
  className?: string;
};

export const ReportSign: FC<ReportSignProps> = (props) => {
  const { user, className } = props;

  const { formatMessage } = useIntl();

  const userLocale = useAppSelector(userModel.selectors.selectUserLocale);

  const userName = getName(user.UserFirstName, user.UserLastName, {
    userLocale,
  });

  const speciality = getFirstValidJobPosition(user?.JobPositions);

  return (
    <div
      className={cn(styles.container, className)}
      data-component="report-signer"
    >
      <div className={styles.signedUser}>
        <p data-ph-mask className={cn(styles.signedUserName, 'p2')}>
          {userName}
        </p>
        {speciality && (
          <p className={cn(styles.signedUserSpeciality, 'p3')}>
            {formatMessage(i18n.specialityType[speciality])}
          </p>
        )}
      </div>
      {user.SignedAt && (
        <p className={cn(styles.signDate, 'p2')}>
          <FormattedDate
            value={user.SignedAt.toDate()}
            day="2-digit"
            month="short"
            year="numeric"
          />{' '}
          <FormattedTime value={user.SignedAt.toDate()} hour12={false} />
        </p>
      )}
    </div>
  );
};
